import CalendarSurfaceStore from '../store/schema/CalendarSurfaceStore';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';
import { createDisplayDate } from 'owa-datetime';
import { createWeekDateRange } from 'owa-datetime-utils';
import { DateRangeType } from 'office-ui-fabric-react/lib/utilities/dateValues/DateValues';
import { FirstWeekOfYear } from 'office-ui-fabric-react/lib/utilities/dateValues/DateValues';

export function createEmptySurfaceStore(): CalendarSurfaceStore {
    // This is called before we have timezone info, so we can't call 'now()'.
    // Let's use a date way in the past; if we see it, we know it will be wrong.
    const selectedDate = createDisplayDate(1900, 0, 1);
    const currentDateRange = createWeekDateRange(0, selectedDate);
    return {
        dayStartMinute: 0,
        dayLength: TimeConstants.MinutesInOneDay,
        dateRange: currentDateRange,
        dateRangeType: DateRangeType.Week,
        selectedDate,
        calendarItems: [],
        monthHeight: 0 /* TODO: Do we need a separate store for month data? */,
        selectedItem: null,
        hoveredItem: null,
        focusedSurfaceElement: null,
        disableTabbableSurfaceItems: false,
        userOptions: {
            isRTL: false,
            weekStartDay: 0,
            showWeekNumbers: false,
            firstWeekOfYear: FirstWeekOfYear.FirstDay,
            hourIncrement: TimeConstants.MinutesInOneHour / 2,
            workDays: TimeConstants.AllDaysOfWeek,
        },
        enableDragDrop: true,
        dragDropState: {
            /* Note: All properties in the drop state must be initialized so mobx can pickup changes */
            draggedItemModel: null,
            dragType: null,
            helperItemModel: null,
            dragStartPosition: null,
            dragStartDate: null,
            dragOffset: null,
            dragPosition: null,
            droppableType: null,
        },
        selectedItemCSSSelector: null,
        dynamicResizeFlag: false,
        isInSplitView: false,
        timeZoneIds: [],
    };
}
